import React from 'react'
import TrackedAccounts from 'components/TrackedAccounts'
import WithdrawalAccount from 'components/WithdrawalAccount'
import RoundupCap from 'components/Fields/RoundupCap'
import TithingPercentage from 'components/Fields/TithingPercentage'
import { Grid, Paper, Box, Button, useMediaQuery } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { updateUser } from 'actions/users'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import useFormExpanded from 'hooks/useFormExpanded'
import { setNotification } from 'actions/status'
import DonationDataExport from './DonationDataExport'

function Financial() {
  const isCommunityAdmin = useCurrentUserProp('isCommunityAdmin')
  const userId = useCurrentUserProp('id')
  const formMethods =  useFormExpanded()
  const { hasErrors, handleSubmit, setFieldValidationErrors, control } = formMethods
  const dispatch = useDispatch()
  function save(values) {
    dispatch(updateUser(userId, values)).then(() => {
      dispatch(setNotification('success', 'Financial settings updated!'))
    }).catch((errorResponse) => {
      setFieldValidationErrors(errorResponse)
    })
  }

  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const gridSpacing = isSmall ? 1 : 3

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item container direction='column' xs={12} sm={6} spacing={gridSpacing}>
        <Grid item>
          <Box p={3} component={Paper}>
            <RoundupCap margin='normal' fullWidth control={control} />
            <TithingPercentage margin='normal' fullWidth control={control} />
            <Button fullWidth size='large' variant='contained' disabled={hasErrors} color='primary' onClick={handleSubmit(save)}>
              save changes
            </Button>
          </Box>
        </Grid>
        <Grid item>
          <WithdrawalAccount />
        </Grid>
      </Grid>
      <Grid item container direction='column' xs={12} sm={6} spacing={gridSpacing}>
        <Grid item>
          <TrackedAccounts />
        </Grid>
        {isCommunityAdmin && (
          <Grid item>
            <DonationDataExport />
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default Financial